
import React from 'react';

const DwollaTOS = (props) => {

  const link = (url, text) => (<a href={url} target="_blank" rel="noopener noreferrer">{text}</a>);

  const dwolla_tos_url = "https://www.dwolla.com/legal/tos";
  const dwolla_pp_url = "https://www.dwolla.com/legal/privacy";

  const text_0 = "We use Dwolla as our payment provider. By checking this box you agree to Dwolla's ";
  return (
    <span style={props.style}>
      {text_0}
      { link(dwolla_tos_url, "Terms of Service") }
      { ' and '}
      { link(dwolla_pp_url, "Privacy Policy") }
    </span>
  );
}

export { DwollaTOS };
